import {Component} from "react";
import * as React from "react";

import moment from "moment";
import {Line} from "react-chartjs-2";
import {LINE_CHART_OPTIONS} from "../WorkloadStatsOverTimeCard";
import {
    MailroomAnalyticsResult,
    MailroomActiveConnectionsOverTimeResultItem
} from "../../models/MailroomAnalyticsResult";
import {DEFAULT_CHART_COLOURS} from "../pages/admin/workloads/WorkloadResultsCharts";
import * as _ from "lodash";

interface MailroomActiveConnectionsOverTimeCardProps
{
    mailroomAnalyticsResult: MailroomAnalyticsResult;
}

interface MailroomActiveConnectionsOverTimeCardState
{
    activeConnectionsData: {t: Date,y: number}[]
}

export default class MailroomActiveConnectionsOverTimeCard extends Component<MailroomActiveConnectionsOverTimeCardProps,MailroomActiveConnectionsOverTimeCardState>
{
    constructor(props: Readonly<MailroomActiveConnectionsOverTimeCardProps>) {
        super(props);

        this.state = {
            activeConnectionsData: [],
        }
    }

    public componentDidMount() {
        if(this.props.mailroomAnalyticsResult)
        {
            this.setData();
        }
    }


    componentDidUpdate(prevProps: Readonly<MailroomActiveConnectionsOverTimeCardProps>, prevState: Readonly<MailroomActiveConnectionsOverTimeCardState>, snapshot?: any): void {
    }

    private setData()
    {
        if(this.props.mailroomAnalyticsResult)
        {
            const activeConnectionsData = this.props.mailroomAnalyticsResult.activeConnectionsOverTimeItems.map((i: MailroomActiveConnectionsOverTimeResultItem) => {
                return {
                    t: moment(i.date).toDate(),
                    y: i.activeConnections,
                };
            });
            
            this.setState({
                activeConnectionsData: activeConnectionsData,
            });
        }
    }

    public render() {

        const barChartData =
            {
                datasets: [{
                    label: "Active inbox connections",
                    data: this.state.activeConnectionsData,
                    borderColor: DEFAULT_CHART_COLOURS[7],
                    fill: false,
                }]
            };
        
        const chartOptions = _.cloneDeep(LINE_CHART_OPTIONS) as any
        chartOptions.scales.yAxes = [
            {
                ticks: {
                    min: 0,
                    suggestedMax: this.props.mailroomAnalyticsResult.numberOfPotentialMailroomSchools
                },
            }
        ];

        return (
            <div className={"card card--padded flex-item--flex-1"}>
                <Line data={barChartData} width={4} height={1} options={chartOptions}/>
                <span className={"p-top-1rem"}>Active Mailroom Inbox Connections</span>
                <span className={"text-extra-detail"}>Number of schools data has been received from in the 7 days prior.</span>
            </div>
        );

    }
}